export const FISH_TYPES = 'fish_types'
export const FISH_MARKET = 'fish_market'
export const FISH_RECIPES = 'fish_recipes'
export const FISH_RESERVATIONS = 'fish_reservations'
export const FISH_RESERVATIONS_LOG = 'fish_reservations_log'
export const FISH_ADDED = 'fish_added'

export const EVENTS = 'events'

export const SET_ACTIVE_ARTICLE = 'set_active_article'
export const ARTICLE_LIST = 'article_list'
export const UPDATE_ARTICLE = 'update_article'

export const LOGIN_MESSAGE = 'login_message'
export const LOCK_LOGIN = 'lock_login'
export const USER_DATA = 'user_data'
export const LOGOUT = 'logout'

export const APP_LOADING = 'app_loading'
export const APP_MESSAGE = 'app_message'
export const SET_CONTRAST = 'set_contrast'
export const FONT_SIZE = 'font_size'

export const USER_LIST_WITH_TYPE = 'user_list_with_type'



// WEBPACK FOOTER //
// ./src/constants/index.js